export default "__VITE_ASSET__HzW6oMB1__"